import { isEmpty } from "@backmarket/utils/object/isEmpty";
import { stringify } from "@backmarket/utils/query-string/stringify";
const isLink = (link) => typeof link !== "string" && "type" in link;
export function toNuxtLink(link) {
  if (isLink(link)) {
    if (link.type === "external") {
      return link.href;
    }
    const {
      name,
      hash,
      params: unsafeParams,
      query,
      pattern
    } = link;
    const filteredParams = pattern ? Object.keys(unsafeParams ?? {}).reduce((acc, param) => {
      const patternParts = pattern.split(/\??\//);
      if (patternParts.includes(`:${param}`)) {
        return { ...acc, [param]: unsafeParams[param] };
      }
      return acc;
    }, {}) : unsafeParams;
    return {
      name,
      query,
      params: filteredParams,
      hash: isEmpty(hash) ? void 0 : `#${stringify(hash)}`
    };
  }
  return link;
}
